/* eslint no-param-reassign: 0 */
import * as types from '../mutation-types';
import DisparosAPI from '../../api/disparos';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  years: [],
  contatos: [],
  uiFlags: {
    isFetchingYears: false,
    isFetchingContatos: false,
    isDispatching: false,
  },
};

export const getters = {
  getYears: $state => $state.years,
  getContatos: $state => $state.contatos,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetchYears: async ({ commit }) => {
    commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingYears: true });
    try {
      const { data } = await DisparosAPI.years();
      commit(types.default.SET_DISPAROS_YEARS, data.years || []);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingYears: false });
    }
  },
  fetchByYear: async ({ commit }, year) => {
    commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingContatos: true });
    try {
      const { data } = await DisparosAPI.byYear(year);
      commit(types.default.SET_DISPAROS_CONTATOS, data.contatos || []);
    } catch (error) {
      throwErrorMessage(error);
      commit(types.default.SET_DISPAROS_CONTATOS, []);
    } finally {
      commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingContatos: false });
    }
  },
  searchContatos: async ({ commit }, term) => {
    commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingContatos: true });
    try {
      const { data } = await DisparosAPI.search(term);
      commit(types.default.SET_DISPAROS_CONTATOS, data.contatos || []);
    } catch (error) {
      throwErrorMessage(error);
      commit(types.default.SET_DISPAROS_CONTATOS, []);
    } finally {
      commit(types.default.SET_DISPAROS_UI_FLAG, { isFetchingContatos: false });
    }
  },
  clearContatos: ({ commit }) => {
    commit(types.default.SET_DISPAROS_CONTATOS, []);
  },
  dispatchSelected: async ({ commit }, { codDivPars, template }) => {
    commit(types.default.SET_DISPAROS_UI_FLAG, { isDispatching: true });
    try {
      const { data } = await DisparosAPI.dispatch(codDivPars, template);
      return data;
    } catch (error) {
      throwErrorMessage(error);
      return { success: false };
    } finally {
      commit(types.default.SET_DISPAROS_UI_FLAG, { isDispatching: false });
    }
  },
};

export const mutations = {
  [types.default.SET_DISPAROS_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [types.default.SET_DISPAROS_YEARS]($state, years) {
    $state.years = years;
  },
  [types.default.SET_DISPAROS_CONTATOS]($state, contatos) {
    $state.contatos = contatos;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
